import * as cookies from "browser-cookies";

const domain = process.env.NODE_ENV === 'production' ? ".upcomi.ng" : "localhost";
export default ({ userId, userToken }) => {
    cookies.set('upcoming-auth-token', userToken, { expires: 365, domain });
    cookies.set('upcoming-auth-user-id', userId, { expires: 365, domain });
}



// WEBPACK FOOTER //
// ./src/user/setLocalUser.ts